import { FavoritesRequest, MemberDetailedInfo, User } from "@/types";

import { axios } from "../axios.instance";

export type GetAdmiresUsersRequest = FavoritesRequest & {
  perPage?: number;
  cursor?: string;
};

export type GetAdmiresUsersResponse = {
  data: Array<Pick<User, "id" | "role"> & MemberDetailedInfo>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getAdmiresUsers = async (params: GetAdmiresUsersRequest): Promise<GetAdmiresUsersResponse> => {
  const { data } = await axios.get(`/admires/users/my-admired`, {
    params,
  });

  return data;
};
